import instObj from '@/backend/axios-instances'

const resource = "/material"
const instance = instObj.baseInstance

export default {
  get(id, parameters) {
    return instance.get(`${resource}/${id}`, { params: parameters });
  },
  put(id, data, parameters) {
    return instance.put(`${resource}/${id}`, data, { params: parameters });
  },
  delete(id) {
    return instance.delete(`${resource}/${id}`);
  },
  addImage(id, data) {
    return instance.post(`${resource}/${id}/image`, data);
  }
}
